import { render } from "./AdminDocPagesPage.vue?vue&type=template&id=2ce0accf&scoped=true"
import script from "./AdminDocPagesPage.vue?vue&type=script&lang=js"
export * from "./AdminDocPagesPage.vue?vue&type=script&lang=js"

import "./AdminDocPagesPage.vue?vue&type=style&index=0&id=2ce0accf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce0accf"]])

export default __exports__